import { motion } from 'motion/react'
import { useInView } from 'motion/react'
import { useRef } from 'react'

function LegacyDiagram() {
  return (
    <div
      style={{
        background: 'rgba(255,80,80,0.04)',
        border: '1px solid rgba(255,80,80,0.15)',
        borderRadius: '16px',
        padding: '2rem',
        height: '100%',
        minHeight: '320px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '12px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '0.7rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'rgba(255,100,100,0.7)',
        }}
      >
        Legacy Engineering
      </div>

      <svg
        viewBox="0 0 300 240"
        style={{ width: '100%', height: '100%', marginTop: '8px' }}
      >
        {/* Tangled mess of pipes */}
        <g opacity="0.7">
          {/* Source boxes */}
          <rect
            x="10"
            y="20"
            width="55"
            height="28"
            rx="4"
            fill="rgba(255,100,100,0.1)"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1"
          />
          <text
            x="37"
            y="38"
            textAnchor="middle"
            fill="rgba(255,200,200,0.8)"
            fontSize="8"
            fontFamily="'DM Sans', sans-serif"
          >
            Source A
          </text>

          <rect
            x="10"
            y="60"
            width="55"
            height="28"
            rx="4"
            fill="rgba(255,100,100,0.1)"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1"
          />
          <text
            x="37"
            y="78"
            textAnchor="middle"
            fill="rgba(255,200,200,0.8)"
            fontSize="8"
            fontFamily="'DM Sans', sans-serif"
          >
            Source B
          </text>

          <rect
            x="10"
            y="100"
            width="55"
            height="28"
            rx="4"
            fill="rgba(255,100,100,0.1)"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1"
          />
          <text
            x="37"
            y="118"
            textAnchor="middle"
            fill="rgba(255,200,200,0.8)"
            fontSize="8"
            fontFamily="'DM Sans', sans-serif"
          >
            Source C
          </text>

          {/* Tangled lines */}
          <path
            d="M65 34 C120 34, 90 74, 145 74"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="4 3"
          />
          <path
            d="M65 74 C100 74, 130 34, 145 44"
            stroke="rgba(255,100,100,0.3)"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="4 3"
          />
          <path
            d="M65 114 C110 114, 100 90, 145 104"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="4 3"
          />
          <path
            d="M65 34 C90 34, 120 114, 145 134"
            stroke="rgba(255,100,100,0.2)"
            strokeWidth="1"
            fill="none"
            strokeDasharray="3 4"
          />

          {/* ETL boxes */}
          <rect
            x="145"
            y="30"
            width="60"
            height="28"
            rx="4"
            fill="rgba(255,160,50,0.08)"
            stroke="rgba(255,160,50,0.3)"
            strokeWidth="1"
          />
          <text
            x="175"
            y="48"
            textAnchor="middle"
            fill="rgba(255,200,150,0.7)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Manual ETL
          </text>

          <rect
            x="145"
            y="68"
            width="60"
            height="28"
            rx="4"
            fill="rgba(255,160,50,0.08)"
            stroke="rgba(255,160,50,0.3)"
            strokeWidth="1"
          />
          <text
            x="175"
            y="86"
            textAnchor="middle"
            fill="rgba(255,200,150,0.7)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Transform
          </text>

          <rect
            x="145"
            y="106"
            width="60"
            height="28"
            rx="4"
            fill="rgba(255,160,50,0.08)"
            stroke="rgba(255,160,50,0.3)"
            strokeWidth="1"
          />
          <text
            x="175"
            y="124"
            textAnchor="middle"
            fill="rgba(255,200,150,0.7)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            More Scripts
          </text>

          <rect
            x="145"
            y="144"
            width="60"
            height="28"
            rx="4"
            fill="rgba(255,160,50,0.08)"
            stroke="rgba(255,160,50,0.3)"
            strokeWidth="1"
          />
          <text
            x="175"
            y="162"
            textAnchor="middle"
            fill="rgba(255,200,150,0.7)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Schema Map
          </text>

          {/* More tangled connections */}
          <path
            d="M205 44 C240 44, 240 74, 255 74"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M205 82 C230 82, 240 44, 255 64"
            stroke="rgba(255,100,100,0.3)"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M205 120 C235 120, 245 90, 255 84"
            stroke="rgba(255,100,100,0.4)"
            strokeWidth="1"
            fill="none"
            strokeDasharray="3 3"
          />
          <path
            d="M205 158 C240 158, 240 120, 255 94"
            stroke="rgba(255,100,100,0.2)"
            strokeWidth="1"
            fill="none"
            strokeDasharray="3 3"
          />

          {/* Output */}
          <rect
            x="255"
            y="44"
            width="36"
            height="60"
            rx="4"
            fill="rgba(255,100,100,0.06)"
            stroke="rgba(255,100,100,0.25)"
            strokeWidth="1"
          />
          <text
            x="273"
            y="78"
            textAnchor="middle"
            fill="rgba(255,200,200,0.6)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Stale
          </text>
          <text
            x="273"
            y="88"
            textAnchor="middle"
            fill="rgba(255,200,200,0.6)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Reports
          </text>

          {/* Warning symbol */}
          <text
            x="160"
            y="210"
            textAnchor="middle"
            fill="rgba(255,100,100,0.5)"
            fontSize="9"
            fontFamily="'DM Sans', sans-serif"
          >
            ⚠ Fragile. Manual. Slow.
          </text>
        </g>
      </svg>
    </div>
  )
}

function AgenticDiagram() {
  return (
    <div
      style={{
        background: 'rgba(74, 144, 226, 0.04)',
        border: '1px solid rgba(74, 144, 226, 0.2)',
        borderRadius: '16px',
        padding: '2rem',
        height: '100%',
        minHeight: '320px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '12px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '0.7rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'rgba(74,144,226,0.8)',
        }}
      >
        Agentic Engineering
      </div>

      <svg
        viewBox="0 0 300 240"
        style={{ width: '100%', height: '100%', marginTop: '8px' }}
      >
        <defs>
          <radialGradient id="agentGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#9D4EDD" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#4A90E2" stopOpacity="0.2" />
          </radialGradient>
        </defs>
        <g>
          {/* Data Sources — left */}
          {['CRM', 'ERP', 'APIs', 'DBs'].map((src, i) => (
            <g key={src}>
              <rect
                x="10"
                y={20 + i * 48}
                width="45"
                height="28"
                rx="6"
                fill="rgba(74,144,226,0.1)"
                stroke="rgba(74,144,226,0.35)"
                strokeWidth="1"
              />
              <text
                x="32"
                y={38 + i * 48}
                textAnchor="middle"
                fill="rgba(160,210,255,0.9)"
                fontSize="8"
                fontFamily="'DM Sans', sans-serif"
              >
                {src}
              </text>
              {/* Clean arrow to center */}
              <path
                d={`M55 ${34 + i * 48} C100 ${34 + i * 48}, 100 120, 128 120`}
                stroke="rgba(74,144,226,0.4)"
                strokeWidth="1.5"
                fill="none"
              />
            </g>
          ))}

          {/* Central Agent Hub */}
          <circle
            cx="150"
            cy="120"
            r="38"
            fill="url(#agentGlow)"
            opacity="0.25"
          />
          <circle
            cx="150"
            cy="120"
            r="28"
            fill="rgba(157, 78, 221, 0.15)"
            stroke="rgba(157, 78, 221, 0.5)"
            strokeWidth="1.5"
          />
          <circle
            cx="150"
            cy="120"
            r="16"
            fill="rgba(157, 78, 221, 0.3)"
            stroke="rgba(157, 78, 221, 0.8)"
            strokeWidth="1"
          />
          <text
            x="150"
            y="116"
            textAnchor="middle"
            fill="white"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
            fontWeight="700"
          >
            AI
          </text>
          <text
            x="150"
            y="126"
            textAnchor="middle"
            fill="rgba(255,255,255,0.8)"
            fontSize="7"
            fontFamily="'DM Sans', sans-serif"
          >
            Agents
          </text>

          {/* Insight outputs — right */}
          {['Insights', 'Products', 'Actions'].map((out, i) => (
            <g key={out}>
              <path
                d={`M172 120 C210 120, 210 ${50 + i * 56}, 245 ${50 + i * 56}`}
                stroke="rgba(74,144,226,0.5)"
                strokeWidth="1.5"
                fill="none"
              />
              <rect
                x="245"
                y={36 + i * 56}
                width="50"
                height="28"
                rx="6"
                fill="rgba(74,144,226,0.12)"
                stroke="rgba(74,144,226,0.4)"
                strokeWidth="1"
              />
              <text
                x="270"
                y={54 + i * 56}
                textAnchor="middle"
                fill="rgba(160,210,255,0.95)"
                fontSize="8"
                fontFamily="'DM Sans', sans-serif"
              >
                {out}
              </text>
            </g>
          ))}

          {/* Self-healing label */}
          <text
            x="150"
            y="215"
            textAnchor="middle"
            fill="rgba(74,144,226,0.7)"
            fontSize="9"
            fontFamily="'DM Sans', sans-serif"
          >
            ✦ Autonomous. Adaptive. Always-on.
          </text>
        </g>
      </svg>
    </div>
  )
}

export function Solution() {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-80px' })

  return (
    <section
      id="solution"
      style={{
        padding: '7rem 2rem',
        background: 'linear-gradient(180deg, #0A0F1F 0%, #0c1222 100%)',
        position: 'relative',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background:
            'linear-gradient(90deg, transparent, rgba(74, 144, 226, 0.3), transparent)',
        }}
      />

      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
          >
            <span
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#4A90E2',
                display: 'block',
                marginBottom: '1rem',
              }}
            >
              Introducing the Agentic Data Engineering Era
            </span>
            <h2
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: 800,
                color: '#ffffff',
                letterSpacing: '-0.03em',
                lineHeight: 1.1,
                marginBottom: '1.25rem',
              }}
            >
              From ETL to{' '}
              <span
                style={{
                  background: 'linear-gradient(135deg, #4A90E2, #9D4EDD)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Intelligence Orchestration.
              </span>
            </h2>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '1.05rem',
                color: 'rgba(255,255,255,0.5)',
                maxWidth: '640px',
                margin: '0 auto',
                lineHeight: 1.7,
              }}
            >
              Synkrasis.ai deploys autonomous AI agents that understand your
              data's context. They don't just extract, transform, and load —
              they{' '}
              <span style={{ color: 'rgba(255,255,255,0.85)' }}>
                reason, adapt, and optimize
              </span>{' '}
              in real-time. We turn your data infrastructure into a
              self-healing, insight-generating engine.
            </p>
          </motion.div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.5rem',
            alignItems: 'stretch',
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          >
            <LegacyDiagram />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{
              duration: 0.7,
              delay: 0.35,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <AgenticDiagram />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
